import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import {
	AuthorizationCodeWithPKCEStrategy,
	SpotifyApi,
} from "@spotify/web-api-ts-sdk";

const SpotifyCallback: React.FC = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const handleAuthCallback = async () => {
			const error = searchParams.get("error");
			if (error) {
				console.error("Spotify OAuth Error:", error);
				useAuthStore.getState().showToast("Spotify login was cancelled.", "warning");
				navigate("/?error=access_denied");
				return;
			}

			// Already have a token — skip the exchange
			if (localStorage.getItem("access_token")) {
				navigate("/", { replace: true });
				return;
			}

			try {
				// SDK detects ?code= in the URL and exchanges it for a token automatically
				const strategy = new AuthorizationCodeWithPKCEStrategy(
					import.meta.env.VITE_SPOTY_CLIENT_ID ?? "",
					import.meta.env.VITE_REDIRECT_URI ?? "http://127.0.0.1:3000/callback",
					["playlist-modify-public"]
				);
				const spotifyClient = new SpotifyApi(strategy);
				const authResult = await spotifyClient.authenticate();
				if (!authResult.authenticated) {
					console.error("Failed to authenticate Spotify client after callback");
					useAuthStore.getState().showToast("Spotify login could not be completed. Please try again.", "error");
					navigate("/?error=missing_code");
					return;
				}

				await useAuthStore.getState().completeLogin(spotifyClient);

				navigate("/", { replace: true });
			} catch (err) {
				console.error("Callback auth error:", err);
				useAuthStore.getState().showToast("Spotify login could not be completed. Please try again.", "error");
				navigate("/?error=missing_code");
			}
		};

		handleAuthCallback();
	}, []);

	return (
		<div>
			<p>Authenticating...</p>
		</div>
	);
};

export default SpotifyCallback;
